import { ActivityIdVo, EnabledVo, SaveActivityDto, LoadUsingGet4Params, Activity, LookForConfigDto, ListUsingGet11Params, ActivityResult, AddCompanyToActivityParam, FindGoodsConfigVo, QueryRemitApplyListUsingGetParams, RemitApplyResult, AuditRemitChannelParam, ListMainCategoryListByPidUsingGet2Params, CompanyCategoryVo, UpdateToInvitingResult
} from '@servicesTypings/drpRequest'
import {
    FreshmanSpuDetailVo, FreshmanSpuRecommendVo, FreshmanSpuFastOrderVo, FreshmanSpuSortedVo, ImportUpdateSortedUsingGetParams, FreshmanRegionGoodsQueryVo, QueryFreshmanCompanyGoodsQtyConfigUsingGetParams, GoodsQtyConfigResult, QueryDrpGoodsConfigUsingGetParams, DrpGoodsConfigVo, ListCatOptionsUsingGet1Params, SimpleUserCatVo, IsConfigDiscountRateUsingGetParams, DisGoodsMultiSupplierQueryNoPriceSkuParam, SkuDrpPriceResult, DisGoodsMultiSupplierQueryItemErpStatusParam, ExcelTipsInfo, CoIdAndStyleCode, DisGoodsMultiSupplierImportSourceParamV3, GetProcessUsingGet6Params, ExcelImportStatus, FreshmanStockPriceVo, QueryCanSeeErpSkuUsingGetParams, ErpDisSku, QueryOptionalPlatformItemUsingGetParams, PlatformSpuVo, ShopItemQueryParam, ShopSpuVo, ComplementShopItemQueryParam, BaseItemSpecCountParam, BaseItemSpecCountResult, BaseItemSpecParam, PlatformSpuStockVo, ShopSpuStockVo
} from '@servicesTypings/goodsRequest'
import {
    CompanyInvestmentVO, MerchantItemDTO, PageAndSort, GoodsSpuVo, PageAndSort3, ViewForCompanyVo, CommonCategoryParam, CompanyPoolVo, PlatformBigParamVO, PlatformVo, DistributorPoolResult, CopySensitiveInfoRequest, ApplyInfoVO, GetMarketApplyStatusUsingGetParams, ApplyStatusInfo, PageAndSort2, GoodsSkuDetailVo, GoodsSpuStatisticsParam, GoodsInvestmentOperateVO, LoadReturnAddressUsingGetParams, AfterSaleAddressResp, PaveGoodsSuccessVo, PageAndSort5, PaveGoodsResult, PageAndSort4, PaveGoodsFailVo, OrderTrendVo, SendTrendVo, CoRemarkVO, OperationLogParam, OperationLogVO, QueryCategoryGroupItemUsingGetParams, CategoryGroupInfo, GoodsSpuStockAndPriceParam, GoodsSpuStockAndPriceVo, FreshmanSkuDetailParam, FreshmanSkuDetailVo } from '@servicesTypings/marketRequest'
import { drpRequest, goodsRequest, marketRequest } from '@/utils/request'
// 寻合作配置接口

// 修改寻合作背景基础配置
/**
 * 修改寻合作背景基础配置
 */
export function saveLookForConfig(data: LookForConfigDto): API.Res<null> {
    return drpRequest.post('/op/baseConfig/saveLookForConfig', { data })
}

// 加载寻合作背景基础配置
/**
 * 加载寻合作背景基础配置
 */
export function getLookForConfig(): API.Res<LookForConfigDto> {
    return drpRequest.get('/op/baseConfig/getLookForConfig')
}

// 查询活动列表
/**
 * 查询好商活动列表
 */
export function getActivityList(params: ListUsingGet11Params): API.Res<ActivityResult[]> {
    return drpRequest.get('/op/activity/list', { params })
}

// 增加商品描述以及视频
/**
 * 增加商品描述以及视频
 */
export function updateDetailFreshman(data: FreshmanSpuDetailVo): API.Res<boolean> {
    return goodsRequest.post('/freshman/goods/updateDetail', { data })
}

// 删除活动
/**
 * 删除好商活动
 */
export function deleteActivity(data: ActivityIdVo): API.Res<null> {
    return drpRequest.post('/op/activity/delete', { data })
}

// 设置启用
/**
 * 设置启用状态
 */
export function setEnabled(data: EnabledVo): API.Res<null> {
    return drpRequest.post('/op/activity/setEnabled', { data })
}

// 新增/修改活动
/**
 * 修改好商活动
 */
export function saveActivity(data: SaveActivityDto): API.Res<null> {
    return drpRequest.post('/op/activity/saveActivity', { data })
}

// 获取单个活动信息
/**
 * 加载单个活动信息
 */
export function getActiveDetail(params: LoadUsingGet4Params): API.Res<Activity> {
    return drpRequest.get('/op/activity/load', { params })
}

// 更新主推状态
/**
 * 商品主推状态更新
 */
export function updateRecommendApi(data: FreshmanSpuRecommendVo): API.Res<boolean> {
    return goodsRequest.post('/freshman/goods/updateRecommend', { data })
}

// 极速推单状态批量更新
/**
 * 极速推单状态批量更新
 */
export function batchUpdateFastOrderApi(data: FreshmanSpuFastOrderVo): API.Res<boolean> {
    return goodsRequest.post('/freshman/goods/batchUpdateFastOrder', { data })
}

// 商品权重更新
/**
 * 商品权重更新
 */
export function updateSortedApi(data: FreshmanSpuSortedVo): API.Res<boolean> {
    return goodsRequest.post('/freshman/goods/updateSorted', { data })
}

// 导入设置权重
/**
 * 导入设置权重
 */
export function importUpdateSortedApi(params: ImportUpdateSortedUsingGetParams): API.Res<string> {
    return goodsRequest.get('/freshman/goods/importUpdateSorted', { params })
}

// 导出
/**
 * 导出
 */
export function exportExcelApi(data: FreshmanRegionGoodsQueryVo): API.Res<string> {
    return goodsRequest.post('/freshman/goods/exportExcel', { data })
}

// 查询所有主推商品
/**
 * 查询所有主推商品
 */
export function queryAllRecommendApi(): API.Res<FreshmanSpuRecommendVo[]> {
    return goodsRequest.post('/freshman/goods/queryAllRecommend')
}

// 选商家开始------------
// 查询商家列表
/**
 * 查询商家列表
 */
export function queryCoIdListApi(data: CompanyInvestmentVO): API.Res<string[]> {
    return marketRequest.post('/merchant/investment/queryCoIdList', { data })
}

// 添加商家池
/**
 * swagger找不到此接口
 */
export function addCompanyPoolApi(data) {
    return marketRequest.post('/merchant/investment/addCompanyPool', {
        data
    })
}

// 添加商家池
/**
 * 查询商家信息列表
 */
export function queryMerchantItemList(data: string[]): API.Res<MerchantItemDTO[]> {
    return marketRequest.post('/merchant/investment/queryMerchantItemList', { data })
}

// 查询SKU选项
/**
 * 查询选品列表
 */
export function investmentList(data: PageAndSort): API.Res<GoodsSpuVo[]> {
    return marketRequest.post('/investment/goods/spuList', { data })
}

// 选品商家视图
/**
 * 选品商家视图
 */
export function viewForCompany(data: PageAndSort3): API.Res<ViewForCompanyVo[]> {
    return marketRequest.post('/investment/viewForCompany', { data })
}

// 查询商家
/**
 * 查询商家详细信息
 */
export function queryGylCoListByPage(data: CommonCategoryParam): API.Res<CompanyPoolVo[]> {
    return marketRequest.post('/merchant/investment/queryGylCoListByPage', { data })
}

// 平台、一级、二级、三级类目 下拉
/**
 * 查询平台类目信息
 */
export function queryPlatformCategory(data: PlatformBigParamVO): API.Res<PlatformVo[]> {
    return marketRequest.post('/merchant/investment/queryPlatformCategory', { data })
}

// 选商家结束-------------------

// 查询分销商
/**
 * 查询选分销商列表
 */
export function queryChannelByPage(data: CommonCategoryParam): API.Res<DistributorPoolResult[]> {
    return marketRequest.post('/merchant/distributor/list', { data })
}

// 拷贝脱敏字段
/**
 * 拷贝脱敏字段
 */
export function copySensitiveInfo(data: CopySensitiveInfoRequest): API.Res<object> {
    return marketRequest.post('/merchant/distributor/copySensitiveInfo', { data })
}

// 大店申请分销商合作
/**
 * 大店申请分销商合作
 */
export function applyingForCooperation(data: ApplyInfoVO[]): API.Res<boolean> {
    return marketRequest.post('/merchant/distributor/applyingForCooperation', { data })
}

// 查询大店商家列表
/**
 * 查询大店商家申请分销商合作状态 targetCoId:分销商coid
 */
export function queryMarketCompany(params: GetMarketApplyStatusUsingGetParams): API.Res<ApplyStatusInfo[]> {
    return marketRequest.get('/merchant/distributor/getMarketApplyStatus', { params })
}

// 添加到好商活动
/**
 * 添加商家进活动
 */
export function addToGoodBussine(data: AddCompanyToActivityParam): API.Res<null> {
    return drpRequest.post('/op/activity/addCompanyToActivity', { data })
}

// 商品sku列表
/**
 * 商品sku列表
 */
export function investmentSkuList(data: PageAndSort2): API.Res<GoodsSkuDetailVo[]> {
    return marketRequest.post('/investment/goods/skuList', { data })
}

// 查询商家池统计数量
/**
 * 查询选入商品池商家数量
 */
export function inGoodsPoolCompanyCount(data: string[]): API.Res<Record<string, number>> {
    return marketRequest.post('/merchant/investment/inGoodsPoolCompanyCount', { data })
}

// 查询商品池统计数量
/**
 * 查询商品池统计数量
 */
export function queryGoodsTypeCount(data: GoodsSpuStatisticsParam): API.Res<Record<string, number>> {
    return marketRequest.post('/investment/queryGoodsTypeCount', { data })
}

// 添加商品池
/**
 * 添加商品池
 */
export function addGoodsPool(data: GoodsInvestmentOperateVO): API.Res<null> {
    return marketRequest.post('/investment/addGoodsPool', { data })
}

// 查询大店商家列表
/**
 * 售后退货地址
 */
export function getLoadReturnAddress(params: LoadReturnAddressUsingGetParams): API.Res<AfterSaleAddressResp> {
    return marketRequest.get('/common/addresses/loadReturnAddress', { params })
}

// 获取第一个大店的coId
/**
 * 获取第一个大店的coId
 */
export function getFirstFreshmanCoId(): API.Res<string> {
    return goodsRequest.get('/op/freshman/getFirstFreshmanCoId')
}

// 查询大店商家商品数量配置
/**
 * 查询大店商家商品数量配置
 */
export function queryGoodsQtyConfig(
    params: QueryFreshmanCompanyGoodsQtyConfigUsingGetParams
): API.Res<GoodsQtyConfigResult> {
    return goodsRequest.get('/op/freshman/limit/queryGoodsQtyConfig', { params })
}

// 查询代发商品导入是否上架到分销小站配置
/**
 * 查询代发商品导入是否上架到分销小站配置
 */
export function queryOpDrpGoodsConfig(params: QueryDrpGoodsConfigUsingGetParams): API.Res<DrpGoodsConfigVo> {
    return goodsRequest.get('/op/freshman/distributor/config/queryDrpGoodsConfig', { params })
}

// 编辑代发商品导入是否上架到分销小站配置
export function editOpDrpGoodsConfig({ data, params }) {
    return goodsRequest.post('/op/freshman/distributor/config/editDrpGoodsConfig', {
        params,
        data
    })
}

// 查询自定义类目下拉列表
/**
 * 查询自定义类目下拉列表
 */
export function listOpCatOptions(params: ListCatOptionsUsingGet1Params): API.Res<SimpleUserCatVo[]> {
    return goodsRequest.get('/op/freshman/goods/goUserCategory/listCatOptions', { params })
}

// 是否配置分销折扣率
/**
 * 是否配置分销折扣率
 */
export function isConfigDiscountRateOp(params: IsConfigDiscountRateUsingGetParams): API.Res<boolean> {
    return goodsRequest.get('/op/freshman/drp/disConfig/isConfigDiscountRate', { params })
}

// 查询在ERP中没有价格或不存在的SKU的采购价
/**
 * 查询在ERP中没有价格或不存在的SKU的采购价
 */
export function queryNoSupplyPriceSkuDrpPrice(
    data: DisGoodsMultiSupplierQueryNoPriceSkuParam
): API.Res<SkuDrpPriceResult> {
    return goodsRequest.post('/op/dis/multi/supplier/queryNoSupplyPriceSkuDrpPrice', { data })
}

// 查询选中商品是否存在于ERP
/**
 * 查询选中商品是否存在于ERP
 */
export function checkOpItemErpStatus(data: DisGoodsMultiSupplierQueryItemErpStatusParam): API.Res<ExcelTipsInfo> {
    return goodsRequest.post('/op/dis/multi/supplier/checkItemErpStatus', { data })
}

// 大店商家批量导入
/**
 * swagger找不到此接口
 */
export function batchImportSkuOp(data) {
    return goodsRequest.post('/op/dis/multi/supplier/freshmanCompany/import/batch', {
        data
    })
}

// 中台匹配商品
/**
 * 匹配供应商平台资料和店铺商品
 */
export function matchSupplierPlatformAndShopItem(data: CoIdAndStyleCode[]): API.Res<string> {
    return goodsRequest.post('/op/freshman/matchSupplierPlatformAndShopItem', { data })
}

// 大店商家批量导入
/**
 * swagger找不到此接口
 */
export function batchImportSkuOpV2(data) {
    return goodsRequest.post('/op/dis/multi/supplier/freshmanCompany/import/batchV2', {
        data
    })
}

// 大店商家批量导入
/**
 * 大店商家批量导入V3
 */
export function batchImportSkuOpV3(data: DisGoodsMultiSupplierImportSourceParamV3): API.Res<string> {
    return goodsRequest.post('/op/dis/multi/supplier/freshmanCompany/import/batchV3', { data })
}

// 获取进度条
/**
 * 获取进度条
 */
export function getProcessOP(params: GetProcessUsingGet6Params): API.Res<ExcelImportStatus> {
    return goodsRequest.get('/op/dis/multi/supplier/getProcess', { params })
}

// 合作校验
export function getDrpPartnerMap({ params, data }) {
    return goodsRequest.post('/op/freshman/getDrpPartnerMap', {
        params,
        data
    })
}

// 查询大店供货价
export function getDesignatedDrpPrice({ params, data }) {
    return goodsRequest.post('/op/freshman/getDesignatedDrpPriceStock', {
        params,
        data
    })
}

// 查看铺货成功分销商明细
/**
 * 查看铺货成功分销商明细
 */
export function getPaveGoodsSuccessDetail(data: PageAndSort3): API.Res<PaveGoodsSuccessVo[]> {
    return marketRequest.post('/sellWell/paveGoodsSuccessDetail', { data })
}

// 查看铺货分销商明细
/**
 * 查看铺货成功分销商明细
 */
export function paveGoodsDetail(data: PageAndSort5): API.Res<PaveGoodsResult[]> {
    return marketRequest.post('/sellWell/paveGoodsDetail', { data })
}

// 查看铺货失败明细
/**
 * 查看铺货成功分销商明细
 */
export function getPaveGoodsFailDetail(data: PageAndSort4): API.Res<PaveGoodsFailVo[]> {
    return marketRequest.post('/sellWell/paveGoodsFailDetail', { data })
}

// 大店发货订单趋势
/**
 * 大店发货订单趋势
 */
export function getDeliverGoodsOrderTrend(data: OrderTrendVo): API.Res<Record<string, SendTrendVo[]>> {
    return marketRequest.post('/sellWell/deliverGoodsOrderTrend', { data })
}

// 加载寻合作找商品基础配置
/**
 * 加载寻合作找商品基础配置
 */
export function loadFindGoodsConfig(): API.Res<FindGoodsConfigVo> {
    return drpRequest.get('/op/baseConfig/loadFindGoodsConfig')
}

// 修改寻合作找商品基础配置
/**
 * 修改寻合作找商品基础配置
 */
export function saveFindGoodsConfig(data: FindGoodsConfigVo): API.Res<null> {
    return drpRequest.post('/op/baseConfig/saveFindGoodsConfig', { data })
}

// 修改备注图片
/**
 * 修改备注图片
 */
export function updateRemarkImage(data: CoRemarkVO): API.Res<boolean> {
    return marketRequest.post('/merchant/investment/updateRemarkImage', { data })
}

// 查询供应商发货订单趋势
/**
 * 查询供应商发货订单趋势
 */
export function getSupplierDeliverGoodsOrderTrend(data: OrderTrendVo): API.Res<Record<string, SendTrendVo[]>> {
    return marketRequest.post('/sellWell/supplierDeliverGoodsOrderTrend', { data })
}

// 异步查询库存价格信息
/**
 * 异步查询库存价格信息
 */
export function asyncQueryStockAndPrice(data: FreshmanStockPriceVo[]): API.Res<FreshmanStockPriceVo[]> {
    return goodsRequest.post('/freshman/goods/asyncQueryStockAndPrice', { data })
}

export interface CategoryTrafficParams {
    /** 类目统计类型：lv1、lv2、lv3  默认lv1 */
    cateLvlType?: string

    /** 一级类目名称 */
    categoryLv1List?: string[]

    /** 二级类目列表 */
    categoryLv2List?: string[]

    /** 三级类目列表 */
    categoryLv3List?: string[]

    /** 类目售后单数 */
    cateAfsCntMax?: number

    /** 类目售后单数 */
    cateAfsCntMin?: number

    /** 类目售后率 */
    cateAfsCntRatioMax?: number

    /** 类目售后率 */
    cateAfsCntRatioMin?: number

    /** 类目营收gmv */
    cateRevenueGmvMax?: number

    /** 类目营收gmv */
    cateRevenueGmvMin?: number

    /** 类目营收gmv占比 */
    cateRevenueGmvRatioMax?: number

    /** 类目营收gmv占比 */
    cateRevenueGmvRatioMin?: number

    /** 类目销售金额增量(环比) */
    cateSaleGmvHbMax?: number

    /** 类目销售金额增量(环比) */
    cateSaleGmvHbMin?: number

    /** 类目销售金额增长率 */
    cateSaleGmvIncrRatioMax?: number

    /** 类目销售金额增长率 */
    cateSaleGmvIncrRatioMin?: number

    /** 类目销售gmv */
    cateSaleGmvMax?: number

    /** 类目销售gmv */
    cateSaleGmvMin?: number

    /** 类目销售gmv占比 */
    cateSaleGmvRatioMax?: number

    /** 类目销售gmv占比 */
    cateSaleGmvRatioMin?: number

    /** 类目销售订单数增量(环比) */
    cateSaleOrderCntHbMax?: number

    /** 类目销售订单数增量(环比) */
    cateSaleOrderCntHbMin?: number

    /** 类目销售订单数增长率 */
    cateSaleOrderCntIncrRatioMax?: number

    /** 类目销售订单数增长率 */
    cateSaleOrderCntIncrRatioMin?: number

    /** 类目销售订单数 */
    cateSaleOrderCntMax?: number

    /** 类目销售订单数 */
    cateSaleOrderCntMin?: number

    /** 类目销售订单占比 */
    cateSaleOrderCntRatioMax?: number

    /** 类目销售订单占比 */
    cateSaleOrderCntRatioMin?: number

    /** 结束时间(包含当天) 2024-03-01 */
    endDate?: string

    /** 上个周期开始时间(包含当天) 2024-03-01，默认startDate */
    preDate?: string

    /** 采购总金额 */
    sentItemPurchaseAmtMax?: number

    /** 采购总金额 */
    sentItemPurchaseAmtMin?: number

    /** 开始时间(包含当天) 2024-01-01 */
    startDate?: string

    /** 动销分销商数（去重） */
    shelfSalesDistrCntMax?: number

    /** 动销分销商数（去重） */
    shelfSalesDistrCntMin?: number

    /** 动销商品数 */
    shelfSalesGoodsCntMax?: number

    /** 动销商品数 */
    shelfSalesGoodsCntMin?: number

    /** 商品动销率 */
    shelfSalesGoodsCntRatioMax?: number

    /** 商品动销率 */
    shelfSalesGoodsCntRatioMin?: number

    /** 动销供应商数（去重） */
    shelfSalesSupplierCntMax?: number

    /** 动销供应商数（去重） */
    shelfSalesSupplierCntMin?: number

    /** 铺货分销商数（去重） */
    shelveDistrCntMax?: number

    /** 铺货分销商数（去重） */
    shelveDistrCntMin?: number

    /** 商品铺货率 */
    shelveRatioMax?: number

    /** 商品铺货率 */
    shelveRatioMin?: number

    /** 铺货成功分销商数（去重） */
    shelveSuccessDistrCntMax?: number

    /** 铺货成功分销商数（去重） */
    shelveSuccessDistrCntMin?: number

    /** 商品铺货成功率 */
    shelveSuccessRatioMax?: number

    /** 商品铺货成功率 */
    shelveSuccessRatioMin?: number

    /** 排序字段 */
    sortMap?: Record<string, 'ASC' | 'DESC'>

    /** 商品点击次数(PV) */
    spuClickPvMax?: number

    /** 商品点击次数(PV) */
    spuClickPvMin?: number

    /** 商品点击人数（UV） */
    spuClickUvMax?: number

    /** 商品点击人数（UV） */
    spuClickUvMin?: number

    /** 商品点击率（UV） */
    spuClickUvRatioMax?: number

    /** 商品点击率（UV） */
    spuClickUvRatioMin?: number

    /** 类目销售订单占比 */
    spuCntOcateSaleOrderCntRatioMinnSaleMin?: number

    /** 有效曝光的商品数(商品曝光UV>=1) */
    spuCntOfEffectiveViewMax?: number

    /** 有效曝光的商品数(商品曝光UV>=1) */
    spuCntOfEffectiveViewMin?: number

    /** 低点击率商品数, 商品点击率<1% */
    spuCntOfLowCtrMax?: number

    /** 低点击率商品数, 商品点击率<1% */
    spuCntOfLowCtrMin?: number

    /** 低曝光商品数（spu) */
    spuCntOfLowViewMax?: number

    /** 低曝光商品数（spu) */
    spuCntOfLowViewMin?: number

    /** 在售商品数（spu） */
    spuCntOnSaleMax?: number

    /** 在售商品数（spu） */
    spuCntOnSaleMin?: number

    /** 商品平均曝光次数（PV） */
    spuPvAvgMax?: number

    /** 商品平均曝光次数（PV） */
    spuPvAvgMin?: number

    /** 商品曝光次数（PV） */
    spuPvMax?: number

    /** 商品曝光次数（PV） */
    spuPvMin?: number

    /** 商品平均曝光人数(UV) */
    spuUvAvgMax?: number

    /** 商品平均曝光人数(UV) */
    spuUvAvgMin?: number

    /** 商品曝光人数（UV） */
    spuUvMax?: number

    /** 商品曝光人数（UV） */
    spuUvMin?: number
}

/**
 * 大店商品类目流量信息
 */
export interface CategoryTrafficInfo {
    /** 一级类目 cateLvlType 为 lv1、lv2、lv3 下展示 */
    categoryLv1Name: string

    /** 二级类目 cateLvlType 为 lv2、lv3 下展示 */
    categoryLv2Name: string

    /** 三级类目 cateLvlType 为 lv3 下展示 */
    categoryLv3Name: string

    /** 类目唯一键  类目间以 `##` 分割 */
    categoryKey: string

    /** 在售商品数 */
    spuCntOnSale: number

    /** 有效曝光的商品数 */
    spuCntOfEffectiveView: number

    spuPv: number
    spuUv: number
    spuPvAvg: number | null
    spuUvAvg: number | null
    /** 低曝光商品数 */
    spuCntOfLowView: number
    spuClickUv: number
    spuClickPv: number
    spuClickUvRatio: number | null
    /** 低点击率商品数 */
    spuCntOfLowCtr: number
    shelveDistrCnt: number
    shelveSuccessDistrCnt: number
    shelveRatio: number | null
    shelveSuccessRatio: number | null
    cateSaleGmv: number
    cateSaleGmvRatio: number | null
    cateSaleGmvHb: number
    cateSaleGmvIncrRatio: number | null
    cateRevenueGmv: number
    cateRevenueGmvRatio: number | null
    cateSaleOrderCnt: number
    cateSaleOrderCntRatio: number | null
    cateSaleOrderCntHb: number
    cateSaleOrderCntIncrRatio: number | null
    cateAfsCnt: number
    cateAfsCntRatio: number | null
    cateAfsCntDistribution: number | null
    /** 动销供应商数 */
    shelfSalesSupplierCnt: number
    /** 动销商品数 */
    shelfSalesGoodsCnt: number
    shelfSalesGoodsCntRatio: number
    /** 动销分销商数 */
    shelfSalesDistrCnt: number
    sentItemPurchaseAmt: number
    spuUvChain: number
    spuCntOnSaleChain: number
    spuCntOfLowViewChain: number
    spuCntOfEffectiveViewChain: number
    spuClickUvRatioChain: number
    shelveRatioChain: number
    shelfSalesGoodsCntChain: number
    cateSaleOrderCntChain: number
    cateSaleGmvChain: number
    cateAfsCntRatioChain: number
    shelfSalesGoodsCntRatioChain: number
    shelfSalesSupplierRatio: number
    joinGoodsCnt: number
    excludeGoodsCnt: number
    joinGoodsCntChain: number
    excludeGoodsCntChain: number
}

/*
 * 查询大店商品流量统计
 */
export function categoryTrafficApi(data: CategoryTrafficParams): API.Res<CategoryTrafficInfo[]> {
    return marketRequest.post('/category/pool/categoryTraffic', { data })
}

/** 预设日期范围枚举 */
export enum PresetDateRange {
    /** 昨天 */
    YESTERDAY = 'yesterday',

    /** 近 7 天 */
    LAST_7_DAYS = 'last7days',

    /** 近 30 天 */
    LAST_30_DAYS = 'last30days',

    /** 本周 */
    THIS_WEEK = 'thisWeek',

    /** 本月 */
    THIS_MONTH = 'thisMonth'
}

interface ConditionBase {
    name: string
    type: 'dateEnum' | 'number' | 'numberRange' | 'percentage' | 'percentageRange' | 'string' | 'dateRange'
}

interface DateEnumValueCondition extends ConditionBase {
    type: 'dateEnum'
    value: PresetDateRange
}

interface NumberValueCondition extends ConditionBase {
    type: 'number'
    value: number
}

interface NumberRangeValueCondition extends ConditionBase {
    type: 'numberRange'
    value: [number | null, number | null]
}

interface PercentageValueCondition extends ConditionBase {
    type: 'percentage'
    value: number
}

interface PercentageRangeValueCondition extends ConditionBase {
    type: 'percentageRange'
    value: [number | null, number | null]
}

interface StringValueCondition extends ConditionBase {
    type: 'string'
    value: string
}

interface DateRangeValueCondition extends ConditionBase {
    type: 'dateRange'
    value: string
}

export type Condition =
    | DateEnumValueCondition
    | NumberValueCondition
    | NumberRangeValueCondition
    | PercentageValueCondition
    | PercentageRangeValueCondition
    | StringValueCondition
    | DateRangeValueCondition

export interface QueryParamsForCategoryJumpParamsApi {
    dateType: PresetDateRange
}

export type CategoryJumpParamsMap = Partial<Record<keyof CategoryTrafficInfo, Condition[] | undefined>>

/**
 * 查询大店类目分析跳转参数
 */
export function categoryJumpParams(data: QueryParamsForCategoryJumpParamsApi) {
    return marketRequest.post('/category/pool/categoryJumpParams', {
        data
    }) as API.Res<CategoryJumpParamsMap>
}

export interface CategoryJumpCompanyKeyApi {
    /** 类目级别 */
    cateLvlType: 'lv1' | 'lv2' | 'lv3'

    /** 类目唯一键、类目间以 `##` 分割 */
    categoryKey: string

    /** 开始时间(包含当天) 2024-01-01 */
    startDate: string

    /** 结束时间(包含当天) 2024-03-01 */
    endDate: string

    /** 跳转字段类型 */
    jumpType: string
}

/** 大店类目分析-返回跳转商家信息 key */
export function categoryJumpCompanyKey(data: CategoryJumpCompanyKeyApi): API.Res<string> {
    return marketRequest.post('/category/pool/categoryJumpCompanyKey', { data })
}

/** 查询大店类目分析-返回跳转商家信息 value */
export interface CompanyInfo {
    /** 商家 ID */
    coId: string

    /** 商家名称 */
    companyName: string
}

/** 查询大店类目分析-返回跳转商家信息 value */
export function categoryJumpCompanyValue(params: { key: string }) {
    return marketRequest.get('/category/pool/categoryJumpCompanyValue', {
        params
    }) as API.Res<CompanyInfo[]>
}

export interface CategorySaleTrendParams {
    /** 类目统计类型 lv1、lv2、lv3 */
    cateLvlType?: 'lv1' | 'lv2' | 'lv3'

    /** 类目唯一键、类目间以 `##` 分割 */
    categoryKeyList?: string[]

    /** 一级类目列表 */
    categoryLv1List?: string[]

    /** 开始时间(包含当天) 2024-01-01 */
    startDate?: string

    /** 结束时间(包含当天) 2024-03-01 */
    endDate?: string
}

export interface CategorySaleTrendInfo {
    /** 类目唯一键 */
    categoryKey: string

    /** 一级类目名 */
    categoryLv1Name: string

    /** 销售趋势，json数组格式 */
    salesTrendJson: string
}

/** 查询大店类目销量趋势 */
export function categorySaleTrendApi(data: CategorySaleTrendParams): API.Res<CategorySaleTrendInfo[]> {
    return marketRequest.post('/category/pool/categorySaleTrend', { data })
}
// 操作日志详情
/**
 * 操作日志详情
 */
export function operationLog(data: OperationLogParam): API.Res<OperationLogVO[]> {
    return marketRequest.post('/operation/log/detail', { data })
}

// 操作日志详情
/**
 * 查询类目选项
 */
export function queryCategoryGroupItem(params: QueryCategoryGroupItemUsingGetParams): API.Res<CategoryGroupInfo> {
    return marketRequest.get('/common/queryCategoryGroupItem', { params })
}

// 中台查询大店可见的sku
/**
 * 查询可见的sku
 */
export function queryCanSeeErpSku(params: QueryCanSeeErpSkuUsingGetParams): API.Res<ErpDisSku[]> {
    return goodsRequest.get('/op/freshman/queryCanSeeErpSku', { params })
}

// 中台大店导入商品 匹配供应商平台资料列表
/**
 * 匹配供应商平台资料列表
 */
export function queryOptionalPlatformItem(params: QueryOptionalPlatformItemUsingGetParams): API.Res<PlatformSpuVo[]> {
    return goodsRequest.get('/op/freshman/queryOptionalPlatformItem', { params })
}

// 中台大店导入商品 匹配供应商店铺商品列表
/**
 * 匹配供应商店铺商品列表
 */
export function queryOptionalShopItem(data: ShopItemQueryParam): API.Res<ShopSpuVo[]> {
    return goodsRequest.post('/op/freshman/queryOptionalShopItem', { data })
}

//  查询可补全的店铺商品
/**
 * 查询可补全的店铺商品
 */
export function queryComplementShopItem(data: ComplementShopItemQueryParam[]): API.Res<string> {
    return goodsRequest.post('/op/freshman/queryComplementShopItem', { data })
}

//  查询基础资料sku数
/**
 * 批量查询基础资料规格数
 */
export function batchQueryBaseItemSpecCount(data: BaseItemSpecCountParam[]): API.Res<BaseItemSpecCountResult[]> {
    return goodsRequest.post('/op/freshman/batchQueryBaseItemSpecCount', { data })
}

//  查询基础资料sku
/**
 * 查询基础资料商品规格列表
 */
export function queryBaseItemSpec(data: BaseItemSpecParam): API.Res<ErpDisSku[]> {
    return goodsRequest.post('/op/freshman/queryBaseItemSpec', { data })
}

/**
 * 查询选品列表库存价格
 */
/**
 * 查询选品列表
 */
export function querySpuListStockAndPrice(data: GoodsSpuStockAndPriceParam[]): API.Res<GoodsSpuStockAndPriceVo[]> {
    return marketRequest.post('/investment/goods/spuList/stockAndPrice', { data })
}

/**
 * 查询平台资料给大店的库存
 */
/**
 * 查询平台资料给大店的库存
 */
export function queryPlatformItemSupplierStock(data: PlatformSpuStockVo[]): API.Res<PlatformSpuStockVo[]> {
    return goodsRequest.post('/op/freshman/queryPlatformItemSupplierStock', { data })
}

/**
 * 查询店铺给大店的库存
 */
/**
 * 查询店铺商品给大店的库存
 */
export function queryShopItemSupplierStock(data: ShopSpuStockVo[]): API.Res<ShopSpuStockVo[]> {
    return goodsRequest.post('/op/freshman/queryShopItemSupplierStock', { data })
}

/**
 * 查询寻合作豁免提报申请列表
 */
export function queryRemitApplyListUsingGET(params: QueryRemitApplyListUsingGetParams): API.Res<RemitApplyResult[]> {
    return drpRequest.get('/op/forbidRechargeRemitApply/queryRemitApplyList', { params })
}

/**
 * 查询商品排序权重信息
 */
export function querySkuPriceListBySpuUsingPOST(data: FreshmanSkuDetailParam): API.Res<FreshmanSkuDetailVo[]> {
    return marketRequest.post('/sellWell/querySkuPriceListBySpu', { data })
}

/**
 * 审核提报豁免的分销商
 */
export function auditRemitChannelUsingPOST(data: AuditRemitChannelParam): API.Res<null> {
    return drpRequest.post('/op/forbidRechargeRemitApply/auditRemitChannel', { data })
}

/**
 * 根据父id查询主营类目
 */
export function listMainCategoryListByPidUsingGET2(
    params: ListMainCategoryListByPidUsingGet2Params
): API.Res<CompanyCategoryVo[]> {
    return drpRequest.get('/op/mainCategory/listByPid', { params })
}
/*
 * 分销关系对-寻合作来源转换为邀约来源
 */
export function updateToInvitingUsingPOST(data: object): API.Res<UpdateToInvitingResult> {
    return drpRequest.post('/op/forbidRechargeRemitApply/updateToInviting', {
        headers: {
            'Content-Type': 'application/json'
        },
        data
    })
}

/**
* 批量修改选品进度 
*/
export function batchUpdateGoodsTagUsingPOST(data: GoodsInvestmentOperateVO): API.Res<boolean> {
    return marketRequest.post('/investment/batchUpdateGoodsTag', { data })
}
